<template>
  <b-navbar-nav class="side-left" :class="toggleMenu ? 'openMenu' : ''">
    <li
      class="nav-item"
      @click.prevent="handleSelectMenu({
        menu: menu.uri,
        submenu: null,
        v2: false,
      })"
      v-for="menu in menus"
      :key="menu.uri"
      :class="defaultRoute.menu === menu.uri ? 'show' : ''"
    >
      <a :href="`/#/${menu.uri}/`" class="nav-link">
        <span>
          {{ menu.name }}
        </span>
      </a>
    </li>
  </b-navbar-nav>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'NavbarMenu',
  computed: {
    ...mapState('application', [
      'defaultRoute',
      'toggleMenu',
      'menus',
    ]),
  },
  methods: {
    ...mapActions('application', ['handleSelectMenu']),
  },
};
</script>
